import React from 'react';
import bro from '../Assets/buyplan/bronze-medal.png';
import sil from '../Assets/buyplan/silver-medal.png';
import gold from '../Assets/buyplan/gold-medal.png';
import { Link } from 'react-router-dom';

const Plans = [
    {
        id: 1,
        title: "Basic",
        img: bro,
        Price: "450",
        subtitle: "*GST as applicable",
        Feature1: "5 Job Posting p/m",
        Feature2: "Upto 250 characters Job Description",
        Feature3: "Standard Job Visibility",
        Feature4: "Email support only",
    },
    {
        id: 2,
        title: "Pro",
        img: sil,
        Price: "850",
        subtitle: "*GST as applicable",
        Feature1: "20 Job Posting p/m",
        Feature2: "Upto 500 characters Job Description",
        Feature3: "Highlighted Job Visibility",
        Feature4: "Chat Support",
    },
    {
        id: 3,
        title: "Ultra",
        img: gold,
        Price: "1600",
        subtitle: "*GST as applicable",
        Feature1: "Unlimited Job Posting",
        Feature2: "Detailed Job Description",
        Feature3: "Advanced Job Visibility",
        Feature4: "Dedicated Support",
    }
];

export default function BuyPlan() {
    return (
        <div className="flex items-center justify-center bg-gray-100 min-h-screen">
            <div className="max-w-7xl bg-white w-full relative my-20 rounded-2xl border-[1px] shadow-md py-8 px-6">
                <div className="text-center mb-10">
                    <h3 className="text-red-400 font-semibold uppercase">Plans</h3>
                    <h1 className="text-3xl font-bold">Upgrade your plan for more features</h1>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {Plans.map((item) => (
                        <div
                            key={item.id}
                            className="border-[1px] rounded-lg shadow-lg p-6 text-center hover:shadow-xl hover:scale-105 transition duration-300"
                        >
                            <div className='flex flex-row gap-4'>

                                <img
                                    src={item.img} 
                                    alt={`${item.title} plan`}
                                    className="w-8 h-8 mb-4"
                                />
                                <h2 className="text-2xl font-bold">{item.title}</h2>
                            </div>
                            <p className="text-xl text-gray-600 font-bold mt-2">₹{item.Price}</p>
                            <p className="text-sm text-gray-400">{item.subtitle}</p>
                            <ul className="mt-4 text-left">
                                <li className="text-gray-600 mb-2">✔ {item.Feature1}</li>
                                <li className="text-gray-600 mb-2">✔ {item.Feature2}</li>
                                <li className="text-gray-600 mb-2">✔ {item.Feature3}</li>
                                <li className="text-gray-600 mb-2">✔ {item.Feature4}</li>
                            </ul>
                            <Link to="/payment" className="mt-4 bg-blue-500 text-white py-2 px-6 rounded-full hover:bg-blue-600 transition">
                                Buy Plan
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
